/**
 * BFS depths from the root node for subtle perspective scaling.
 *
 * @param {string} rootKey
 * @param {!Array<{source: string, target: string}>} edges
 * @return {!Object<string, number>}
 */
export function computeNodeDepths(rootKey, edges) {
  if (!rootKey) {
    return {};
  }
  /** @type {Object<string, string[]>} */
  const adjacency = {};
  edges.forEach(edge => {
    if (!adjacency[edge.source]) {
      adjacency[edge.source] = [];
    }
    adjacency[edge.source].push(edge.target);
  });
  /** @type {Object<string, number>} */
  const depths = { [rootKey]: 0 };
  /** @type {string[]} */
  const queue = [rootKey];
  while (queue.length) {
    const key = queue.shift();
    (adjacency[key] || []).forEach(child => {
      if (depths[child] === undefined) {
        depths[child] = depths[key] + 1;
        queue.push(child);
      }
    });
  }
  return depths;
}
